import React, { useEffect, useState, useContext } from "react";
import "moment/locale/th";
import { useNavigate } from "react-router";
import * as adminApi from "../../../../service/adminApi";
import { CurrentUserContext } from "../../../../App";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
import TableSearchV1 from "../../../tableV1/tableSearchV1";
import { RedirectCode400 } from "../../../RedirectCode400";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import format from "date-fns/format";

function FAQ() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [guidelineList, setGuidelineList] = useState([]);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalGuideline, setTotalGuideline] = useState(null);
  const [sortBy, setSortBy] = useState({ id: "", desc: false });
  
  const [filters, setFilters] = useState({
    title: "",
    detail: "",
    owner: "",
    "create_date.date": "",
    "update_date.date": "",
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchGuidelines();
  }, [page, filters, sortBy]);

  const fetchGuidelines = async () => {
    setLoading(true);
    let res = await adminApi.getFAQ(
      page,
      10,
      filters.title,
      filters.detail,
      formatDate(filters["create_date.date"]),
      formatDate(filters["update_date.date"]),
      sortBy.id,
      sortBy.id ? (sortBy.desc ? "desc" : "asc") : "",
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setGuidelineList(res["data"]["faq_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
        setTotalGuideline(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const removeFAQ = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["title"]} ใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await adminApi.removeFAQ(item["faq_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        fetchGuidelines();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setGuidelineList([]);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "yyyy-MM-dd");
  };

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "หัวข้อ",
      accessor: "title",
      Filter: "text",
    },
    {
      Header: "คำตอบ",
      accessor: "detail",
      Cell: ({ row }) => {
        const detail = row.original.detail;
        return (
          <div
            className="truncate w-full max-w-[1000px] max-h-[100px]"
            title={detail}
            dangerouslySetInnerHTML={{ __html: detail }}
          />
        );
      },
      Filter: "text",
    },
    {
      Header: "ผู้สร้าง",
      accessor: "created_by",
      Cell: ({ row }) => {
        const name = `${row.original.created_by.fname} ${row.original.created_by.lname}`;
        return <div dangerouslySetInnerHTML={{ __html: name }} />;
      },
      // Filter: "text",
    },
    {
      Header: "วันที่แจ้ง",
      accessor: "create_date.date",
      Cell: ({ row }) => {
        const createdDate =
          row.original.create_date && row.original.create_date.date
            ? row.original.create_date.date
            : null;
        return createdDate ? formatDateThai(createdDate) : "";
      },
      Filter: "date",
    },
    {
      Header: "วันที่แก้ไข",
      accessor: "update_date.date",
      Cell: ({ row }) => {
        const updatedDate =
          row.original.update_date && row.original.update_date.date
            ? row.original.update_date.date
            : null;
        return updatedDate ? formatDateThai(updatedDate) : "";
      },
      Filter: "date",
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "actions",
      Cell: ({ row }) => {
        const i = row.original;

        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#DFEEFA 0% 0% no-repeat padding-box" }}
              onClick={() => {
                navigate(`/admin/management/faq/view-faq/${i["faq_id"]}`, {
                  state: {
                    type: "faq",
                    id: i["faq_id"],
                    title: i["title"],
                    detail: i["detail"],
                    fname: i["created_by"]["fname"],
                    lname: i["created_by"]["lname"],
                    create_date: i["create_date"]["date"],
                    update_date: i["update_date"]
                      ? i["update_date"]["date"]
                      : i["create_date"]["date"],
                  },
                });
              }}
            >
              <FaEye className="text-[#46A8F4] h-[14px]" />
            </div>
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#AFEBE3 0% 0% no-repeat padding-box" }}
              onClick={() => {
                navigate("/admin/management/faq/edit-faq", {
                  state: {
                    type: "faq",
                    id: i["faq_id"],
                    weight: i["weight"],
                    title: i["title"],
                    detail: i["detail"],
                  },
                });
              }}
            >
              <FaEdit className="text-[#00917E] h-[14px]" />
            </div>
            <button
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
              onClick={() => removeFAQ(i)}
            >
              <FaTrash className="text-[#D32736] h-[14px]" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <div className="mt-[60px]"></div>
      <div>
        <PageHeaderV2 titlename={"คำถามที่พบบ่อย"} />
        <TableSearchV1
          columns={columns}
          data={guidelineList}
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          total={totalGuideline}
          page={page}
          maxPage={maxPage}
          setPage={setPage}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          addData={{
            name: "เพิ่มคำถามที่พบบ่อย",
            url: "/admin/management/faq/add-faq",
            type: "faq",
          }}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />
      </div>
    </div>
  );
}

export default FAQ;
